if (!customElements.get('product-comparison-table')) {
  // Shows or hides the rows behind "Mehr anzeigen" (KT-WOR-5544).
  class ProductComparisonTable extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('.product-comparison__toggle');
      if (!this.toggleButton) return;

      this.toggleLabel = this.toggleButton.querySelector('.product-comparison__toggle-label');
      this.toggleButton.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const expanded = this.toggleButton.getAttribute('aria-expanded') !== 'true';
      this.querySelectorAll('[data-comparison-extra]').forEach((row) => {
        row.hidden = !expanded;
      });
      this.toggleButton.setAttribute('aria-expanded', String(expanded));
      this.toggleLabel.textContent = expanded
        ? this.toggleButton.dataset.labelLess
        : this.toggleButton.dataset.labelMore;
    }
  }

  customElements.define('product-comparison-table', ProductComparisonTable);
}
